module.exports = __webpack_public_path__ + "img/error-triangle.a6ed2361.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/error-triangle.svg
// module id = 8Kvj
// module chunks = 1